import axios from 'axios';
import qs from "qs";

const rootApp = axios.create({
    baseURL: ''
});

const stayAlive = () => rootApp.get('index.php?r=aprendo/StayAlive');
const doLogout = () => rootApp.get('index.php?r=aprendo/logout');
const AsignPeopleToCourse = ({courseId, body}) => rootApp.post(`index.php?r=people/AsignPeopleToCourse&id=${courseId}`, qs.stringify(body, { arrayFormat: 'brackets' }));
const removeUserFromCourse = ({ body}) => {
    var xsrfMatch = document.cookie.match(/XSRF-TOKEN=([^;]+)/);
    var xsrfToken = xsrfMatch ? xsrfMatch[1] : '';
    xsrfToken = xsrfToken !== '' ? xsrfToken : (typeof XSRF_TOKEN !== 'undefined') ? XSRF_TOKEN : '';
    return rootApp.post(`index.php?r=CoursePeople/RemovePeopleCourse&id=7`, qs.stringify({...body, 'X-XSRF-TOKEN': xsrfToken}));
};
const ListUserCourses = ({userId, body}) => rootApp.post(`index.php?r=report/ListUserCourses/id/${userId}/limit/10&page=1`, qs.stringify(body, { arrayFormat: 'brackets' }));
const listPeople = ({body}) => rootApp.post(`/index.php?r=coursePeopleTeam/ListPeople`, qs.stringify(body, { arrayFormat: 'brackets' }));


const getModules = ({body}) => rootApp.post('/index.php?r=courseModule/getCourseModule',qs.stringify(body))

const updateOnlineSettings = ({body}) => rootApp.post('/index.php?r=course/create', qs.stringify(body))

const addModule = ({ body }) => rootApp.post('/index.php?r=courseModule/addModule', qs.stringify(body))

// const EditAssignmentInstructions = ({Course}) => rootApp.post('/index.php?r=courseModule/EditAssignmentInstructions', qs.stringify(Course))



export default {
  getModules,
  updateOnlineSettings,
  addModule
};
